export interface BodyPart {
  painLevel: number;
  color: string;
}

export enum BodyPartLabel {
  BodyElbowsRight = 'BodyElbowsRight',
  BodyElbowsLeft = 'BodyElbowsLeft',
  BodyWristsHandsRight = 'BodyWristsHandsRight',
  BodyWristsHandsLeft = 'BodyWristsHandsLeft',
  BodyKneesRight = 'BodyKneesRight',
  BodyKneesLeft = 'BodyKneesLeft',
  BodyHipsThighs = 'BodyHipsThighs',
  BodyShouldersRight = 'BodyShouldersRight',
  BodyShouldersLeft = 'BodyShouldersLeft',
  BodyAnklesFeetLeft = 'BodyAnklesFeetLeft',
  BodyAnklesFeetRight = 'BodyAnklesFeetRight',
  BodyUpperback = 'BodyUpperback',
  BodyLowerback = 'BodyLowerback',
  BodyNeck = 'BodyNeck'
}

export interface BodyPartPain {
  bodyPart: BodyPart;
  painLevel: number;
}

export enum BodyPainColor {
  LEVEL_10 = '#8C260D',
  LEVEL_9 = '#91370D',
  LEVEL_8 = '#93460C',
  LEVEL_7 = '#97560C',
  LEVEL_6 = '#9C670B',
  LEVEL_5 = '#A0770B',
  LEVEL_4 = '#A3870B',
  LEVEL_3 = '#82920B',
  LEVEL_2 = '#689B0B',
  LEVEL_1 = '#4DA40B',
  NOPAIN = 'rgba(44, 218, 255, 0.69)',
  NO_PAIN_SELECTED = '#fff',
}

export const BODY_PARTS: Record<BodyPartLabel, BodyPart> = {
  [BodyPartLabel.BodyElbowsRight]: {
    painLevel: -1,
    color: BodyPainColor.NOPAIN
  },
  [BodyPartLabel.BodyElbowsLeft]: {
    painLevel: -1,
    color: BodyPainColor.NOPAIN
  },
  [BodyPartLabel.BodyWristsHandsRight]: {
    painLevel: -1,
    color: BodyPainColor.NOPAIN
  },
  [BodyPartLabel.BodyWristsHandsLeft]: {
    painLevel: -1,
    color: BodyPainColor.NOPAIN
  },
  [BodyPartLabel.BodyKneesRight]: {
    painLevel: -1,
    color: BodyPainColor.NOPAIN
  },
  [BodyPartLabel.BodyKneesLeft]: {
    painLevel: -1,
    color: BodyPainColor.NOPAIN
  },
  [BodyPartLabel.BodyHipsThighs]: {
    painLevel: -1,
    color: BodyPainColor.NOPAIN
  },
  [BodyPartLabel.BodyShouldersRight]: {
    painLevel: -1,
    color: BodyPainColor.NOPAIN
  },
  [BodyPartLabel.BodyShouldersLeft]: {
    painLevel: -1,
    color: BodyPainColor.NOPAIN
  },
  [BodyPartLabel.BodyAnklesFeetLeft]: {
    painLevel: -1,
    color: BodyPainColor.NOPAIN
  },
  [BodyPartLabel.BodyAnklesFeetRight]: {
    painLevel: -1,
    color: BodyPainColor.NOPAIN
  },
  [BodyPartLabel.BodyUpperback]: {
    painLevel: -1,
    color: BodyPainColor.NOPAIN
  },
  [BodyPartLabel.BodyLowerback]: {
    painLevel: -1,
    color: BodyPainColor.NOPAIN
  },
  [BodyPartLabel.BodyNeck]: {
    painLevel: -1,
    color: BodyPainColor.NOPAIN
  }
};
